<template>
  <div  class="popup" v-show="restoreShow" v-cloak>
         <div class="content" id='backupRestore'>
             <div class="title">
             {{$t('language.cloudExploer.restore')}}
            <div class="icon white-close dialog-close" @click="restoreClose()"></div>
             </div>
              <div class="backup-options-body">
                  <span v-show="stepOne && execute">
                         <div class="backup-line"><span style='float:left;marginRight:20Px;'>{{$t('language.cloudBackup.selectVersions')}}</span> 
                         <selects ref="selectOne" style="marginLeft:0Px;marginTop:5Px;"  :selectOption="selectTimeOption" @changeOption="onChangeOptionTime" :placeholder="selecTimeValue"></selects>
                         </div>
                         <div class="backup-line"><span style='float:left;marginRight:15Px;'>{{$t('language.cloudBackup.restoreOptions')}}</span>
                          <selects ref="selectTwo" style="marginLeft:0Px;marginTop:5Px;" :selectOption="selecttypeOption"  @changeOption="onChangeOptionType"  :placeholder="selectValue"></selects>
                          </div>
                         <div class="backup-middle">
                             {{$t('language.cloudBackup.selectFiles')}}
                         </div>
                         <div  :class="[errorshow?'backup-box backup-box-relative':'backup-box']" id="restore-tree-app" v-loading="loading">
                                <el-scrollbar style="height:100%;" ref="elscrollbarOne">
                               <el-tree  lazy :load="loadNode" :data="catalogModel" ref="tree1"   :props="defaultProps" :check-on-click-node=false node-key="keyId" empty-text=""  :show-checkbox=true :expand-on-click-node=true  highlight-current @check="checkNode"  @check-change="changeCheckStatus">
                               <span slot-scope="{node,data}" style="width:85%;" v-if="openPanel" v-cloak>
                                     <div class="tree-icon-position" :class="[data.appName?returnName(data.appName):'small-file',!data.appName&&data.dir?'folder-small folder-option-icon':'',!data.dir&&!data.appName?matchfileType(data.name)+'-small folder-option-icon':'']"></div>
                                     <div class="node-name" :title="node.label">{{node.label|ellipsis}}</div>
                               </span>
                               </el-tree>
                               <div v-if="errorshow" style="font-size:14px;color:red;position:absolute;top:0">
                                   {{$t('language.cloudBackup.notFind')}}
                               </div>
                              </el-scrollbar>
                          </div>
                   <div class="backup-botton">
                        <button style="float:right;width:110Px;" @click="next()">{{$t('language.popup.reportPopup.next')}} ></button>
                   </div>
                   </span>
                   <span v-if="!execute">
                         <div style="height:450px"> {{$t('language.cloudSync.notRun')}} </div>
                          <!-- <div class="backup-botton">
                        <button style="float:right;width:110Px;" @click="next()">{{$t('language.popup.reportPopup.next')}} ></button>
                         </div> -->
                   </span>
                   <span v-show="!stepOne">
                          <div class="backup-two-line"  v-for="(item, index) in radioItems" :key="index">
                              <div class="icon-util" @click="radioCurrent=index" :class="[radioCurrent==index?'check-radio':'radio']" style="float:left;position:relative;top:10Px;marginRight:10Px"></div>
                              <div style="float:left;">{{item}}</div></div>
                          <div class="backup-box-two">
                               <div class="backup-new-location tree-nodes" id="treeNodes" v-if="radioCurrent==1">
                                    <el-scrollbar style="height:100%;" ref="elscrollbar">
                                     <ul :key="index" v-for="(item,index) in model">
                                     <tree ref="tree2" :model="item" :index="index" :treeShow=true :transferAimFlag=false></tree>
                                    </ul>
                                     </el-scrollbar>
                               </div>
                          </div>
                           <div class="backup-botton">
                                 <button style='float:right;width:120Px;' @click="executeRestore()">{{$t('language.cloudExploer.restore')}}</button>
                                 <button class="backButton" @click="back()"> ＜ {{$t('language.cloudExploer.back')}} </button>
                           </div>
                   </span>
              </div>
         </div>
        <editCloudNoticDialog ref="editCloudNoticDialog"></editCloudNoticDialog>
  </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import selects from "@/components/common/select/restore_select";
import tree from "@/components/common/trees/tree";
import taskListUtils from "@/js/workspace/task_list_util.js";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
import editCloudNoticDialog from "@/components/popup/add_cloud_popups/edit_cloud_notic_popup";
export default {
     components: {
         selects,
         tree,
         editCloudNoticDialog
     },
     data:function(){
         return{
             loading:true,//表示还原的目录是否还在加载
             restoreShow:false,
             stepOne:true,
             radioItems:[this.$t('language.cloudBackup.restoreOriginal'),this.$t('language.cloudBackup.restoreNewLocation')],
             radioCurrent:0,
             model: [],
             catalogModel:[
            //      {
            //      appName: "oneDrive",
            //      dir: true,
            //      id: "/New Folder(33)/MultCloud Cloud Backup/Task 13_20210623110845",
            //      name: "Task 13_20210623110845",
            //  }
             ],
             catalogModelCopy:[],
             deleteOption:null,
             versions:[],
             timeOptionAll:[],
             defaultProps: {
                children: "children",
                label: "name",
                isLeaf: 'leaf'
            },
            openPanel:true,
             selecttypeOption:[
                //  {
                //     name: 'Always Keep the latest file',
                //     icon: false,
                //     id: 1
                // },
                {
                    name: this.$t('language.cloudBackup.overWriteFile'),
                    icon: false,
                    id:1
                },
                {
                    name: this.$t('language.cloudBackup.skipFile'),
                    icon: false,
                    id: 2
                },
                  
                {
                    name: this.$t('language.cloudBackup.keepTwoFile'),
                    icon: false,
                    id:3
                },

             ],
                selectOptionAll:[
                 {
                    name: this.$t('language.cloudBackup.keepLatest'),
                    icon: false,
                    id: 0
                },
                {
                    name:this.$t('language.cloudBackup.overWriteFile'),
                    icon: false,
                    id:1
                },
                {
                    name: this.$t('language.cloudBackup.skipFile'),
                    icon: false,
                    id: 2
                },
                 {
                    name: this.$t('language.cloudBackup.keepTwoFile'),
                    icon: false,
                    id:3
                },
             ],
             selectTimeOption:[],
             selectValue: this.$t('language.cloudBackup.keepLatest'),
             selecTimeValue:'',
             deleteOption:null,
             vd:null,
             vNum:null,
             restoreItems:null,
             itemIndex:-1,
             options:{
                 replace:3
             },
             restoreItem:null,
             checkKeyIdArr:null,
             execute:true,//任务是否执行
             backupId:null,
             versionNum:null,
             isSources:false,//表示该任务是否是多源
             errorshow:false,
             isExecute:false,//表示是否请求创建任务中
         }
     },
     mounted(){
        this.model = Object.assign([], this.$store.getters.getUsersDrives).filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
        if (!this.model.length ) {
            let that = this;
         this.model = this.Utils.getAllCloudsList(function (res) {
             });
        //不需要邮箱
        this.model = this.model.filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
        }
     },
     watch:{
       restoreShow(newValue,oldValue){
            var that = this;
                if(!newValue){
                this.model=[];
                this.$store.state.syncClickItem=[];
                this.$store.state.syncArr = [];
                this.$store.state.arr = [];
                this.$store.state.clickItem = [];
                //that.$nextTick(()=>{
                if(that.$refs['elscrollbar']){
                  let div = that.$refs['elscrollbar'].wrap; //获取滚动条
				  div.scrollTop = 0;
                }
                //});
                return;
                }
                this.radioCurrent=0;
                this.$forceUpdate();
                this.model = Object.assign([], this.$store.getters.getUsersDrives);
                var notSupportDrive = ['oneDrive4Business','baiDu','sharedWithMe','boxBusiness','sharedDrive'];
                var arr = [];
                for (let index = 0; index < this.model.length; index++) {
                const element = this.model[index];
                 if(!notSupportDrive.includes(element.appName)){
                    arr.push(element);
                  }
                }
                this.model = arr;
                  that.$nextTick(()=>{
                 if(that.$refs['elscrollbar']){
                  let div = that.$refs['elscrollbar'].wrap; //获取滚动条
				  div.scrollTop = 0;
                }
                 });
                this.$forceUpdate();
                $.each(that.model, function(index, item) {
				item.open = false;
				if (item.children && item.children.length) {
				commonUtils.closeTree(item.children);
				}
			 });
       }
     },
     methods:{
         restoreClose(){
             this.restoreShow=false;
         },
         //用户点击next按钮
         next(){
             this.checkKeyIdArr=[];
             let res = this.$refs.tree1.getCheckedNodes();
             if(!res.length){
                           this.$toast({
                            text:this.$t('language.cloudBackup.toRestore'),
                            type: 'fail',
                            idValue: "rightContBan"
                        });
                        return false;
             }
             var checkNodes = Object.assign([],res);
             let allArr = this.deleteFatherChildren(checkNodes);
             this.vd=null;//版本号id
             this.restoreItems=[];
             for (let index = 0; index < allArr.length; index++) {
                 var item = allArr[index];
                 let restoreItem = {};
                 if(!this.checkKeyIdArr.includes(item.keyId)){
                 this.checkKeyIdArr.push(item.keyId);
                 }
                 //封装用户选择的项,封装在restoreItem
                 this.packData(item);
                 if(this.restoreItem instanceof Array ){
                     if(this.restoreItem){
                     this.restoreItems = this.restoreItem;
                     }
                 }else{
                     if(this.restoreItem && this.restoreItem.fileId){
                      if(!this.restoreItems.includes(this.restoreItem)){
                      this.restoreItems.push(this.restoreItem);
                      }
                     }
                 }
             }
             if(this.timeOptionAll.length == 1 || !this.deleteOption){
                this.vd=this.timeOptionAll[0].bId;
                this.vNum=this.timeOptionAll[0].versionNum;
             }
              if(this.timeOptionAll.length > 1 && this.deleteOption){
                this.vd=this.deleteOption[0].bId;
                this.vNum=this.deleteOption[0].versionNum;
             }
             //console.log(this.restoreItem);
             this.stepOne=false;
         },
         packData(data){
             this.restoreItem=null;
            if(data.appName && !this.isSources){//如果选择的是根目录，并且不是多源任务
              return null;
            } 
             if(data.appName && this.isSources){//如果选择的是根目录，并且是多源任务
             this.restoreItem ={
                 fileId:data.fileId,
                 filename:data.filename
             }
             return null;
            }
            if(data.data || data.pnode){
                let newData;
                if(data.data){
                    newData = data.data;
                }
                if(data.pnode){
                    newData = data;
                }
                if(newData.pnode){
                    if(this.restoreItems.length){//如果还原项里面存在长度，看是否存在起节点的父节点
                        this.searchData(newData,newData.pnode,this.restoreItems);
                    }else{
                        this.packData(newData.pnode);
                    }
                }else{
                    this.restoreItem={};
                    this.restoreItem.fileId = newData.fileId;
                    this.restoreItem.filename = newData.name;
                    this.restoreItem.driveId = newData.driveId;
                    this.packChildren(newData);
                    return this.restoreItem;
                }
            }
         },
         //查找数据
         searchData(newData,nPnode,Arr){
             var findFlag = false;
            for (let index = 0; index < Arr.length; index++) {
                const element = Arr[index];
                if(element.filename == nPnode.data.name && (element.fileId == nPnode.data.id || element.fileId == nPnode.data.fileId) && element.driveId ==  nPnode.data.driveId){
                   //var length =  element.children.length;
                   var item = {
                       fileId:newData.id,
                       filename:newData.name,
                       driveId:newData.driveId
                   }
                   if(!element.children){
                       element.children = [];
                   }
                   element.children.push(item);
                   findFlag=true;
                }
                if(index == Arr.length-1){
                    if(!findFlag){//如果没有可以合并的项
                          if(element.children&& element.children.length){
                          this.searchData(newData,nPnode,element.children);
                         }else{
                           this.packData(nPnode);
                         }
                        
                    }
                }
                 
            }
         },
         packChildren(data){
             if(data.children && data.children.length){
                // if(data.children.length == 1){
                //    this.restoreItem.children=[];
                //    var children={};
                //    children.fileId = data.children[0].id;
                //    children.filename= data.children[0].name;
                //    children.driveId= data.children[0].driveId;
                //    this.restoreItem.children.push(children);
                //    this.packChildren(data.children[0]);
                // }else{
                    for (let index = 0; index < data.children.length; index++) {
                        const element = data.children[index];
                        if(this.checkKeyIdArr.includes(element.keyId)){
                             this.packEndChildrenData(this.restoreItem,element);
                             return  this.restoreItem;
                        }else{
                              if(element.children && element.children.length){
                                 this.packEndChildrenData(this.restoreItem,element);
                                 this.packChildren(element);
                             }
                        }
                      
                    }
                // }
             }
         },
         packEndChildrenData(restoreItem,element){
             if(restoreItem.children && restoreItem.children.length ){
                for(var i=0;i<restoreItem.children.length;i++){
                    this.packEndChildrenData(restoreItem.children[i],element);
                }
             }else{
                restoreItem.children=[];
                var children={};
                children.fileId = element.id;
                children.filename=element.name;
                children.driveId= element.driveId;
                restoreItem.children.push(children);
                return this.restoreItem;

             }
         },
         packagerestoreItem(item,restoreItem){
           if(item.children && item.children.length){
              restoreItem.fileId=item.id;
              restoreItem.filename=item.name
              restoreItem.children=[];
              for (let index = 0; index < item.children.length; index++) {
                  const itemElement = item.children[index];
                  let childrenItem={};
                  childrenItem = this.packagerestoreItem(itemElement,childrenItem);
                  restoreItem.children.push(childrenItem);
                  if(index == item.children.length-1){
                     return restoreItem;
                  }
              }
            }else{
            if(item.appName){//如果选择的是根目录
              restoreItem=null;
              return restoreItem;
            }else{
              restoreItem.fileId=item.id;
              restoreItem.filename=item.name;
              restoreItem.driveId= item.driveId;
             return restoreItem;

            }
            }       
            
         },
         back(){
             this.stepOne=true;
         },
           //对选中数据进行判断，若父亲已勾选则子节点无需再加入，遍历已选择数据的children,若children==已选中的数组，将该数据删除;
        deleteFatherChildren(res) {
            var allArr = Object.assign([], res);
            for (let i = 0; i < res.length; i++) {
                if (res[i].children) {
                    for (let j = 0; j < res[i].children.length; j++) {
                        for (let k = 0; k < allArr.length; k++) {
                            if (res[i].children[j] == allArr[k]) {
                                allArr.splice(k, 1);
                                break;
                            }
                        }

                    }
                }
            }
            return allArr;
        },
         onChangeOptionType(newValue){
            let that=this;
            let allOptin = Object.assign([], this.selectOptionAll);
            for (let index = 0; index < allOptin.length; index++) {
                const name = allOptin[index].name;
                if(newValue == name){
                    if(newValue == this.$t('language.cloudBackup.keepLatest')){
                       that.options.replace=3;
                    }
                    if(newValue == this.$t('language.cloudBackup.overWriteFile')){
                       that.options.replace=4;
                    }
                    if(newValue == this.$t('language.cloudBackup.skipFile')){
                       that.options.replace=2;
                    }
                    if(newValue == this.$t('language.cloudBackup.keepTwoFile')){
                       that.options.replace=0;
                    }
                    that.selectValue = name;
                    this.selecttypeOption= Object.assign([], this.selectOptionAll);
                    if(!this.selecttypeOption.includes(this.selectOptionAll[0])){
                    this.selecttypeOption.unshift(this.selectOptionAll[0]);
                }
                    //this.selecttypeOption.splice(index,1);
                    return;
                }
            }         
         },
         //第一个时间选项
         onChangeOptionTime(newValue){
            let that=this;
            let allTime = Object.assign([], this.timeOptionAll);
            for (let index = 0; index < allTime.length; index++) {
                const name = allTime[index].name;
                if(newValue == name){//每次切换数据时改变对应下面版本
                    this.vNum= allTime[index].versionNum;
                    this.selectTimeOption= Object.assign([], this.timeOptionAll);
                    this.deleteOption =[allTime[index]];
                    this.versionNum = allTime[index].versionNum;
                    this.swicthVersion();
                    return;
                }
            }         
         },//切换版本号
         swicthVersion(){
             //this.catalogModel = Object.assign([],this.catalogModelCopy);
              let listData = {
               ud: commonUtils.getUser().id,
               id:this.deleteOption[0].backupId,//backupId
               type:6,
               bpid:0,//父级id，根目录为0，从configId中获取
               vd: this.deleteOption[0].versionNum//版本号，从版本中获取
           }
            let allDrivesArr=this.$store.getters.getUsersDrives;
            this.loading =true;
            var that = this;
            this.errorshow = false;
            that.Utils.doTasksRequest("list_restore", listData).then(res => {
                if(res.status == 200){
                    that.loading = false;
                     this.catalogModel=[];
                  for (let index = 0; index < allDrivesArr.length; index++) {
                  const driveInfo = allDrivesArr[index];
                  for (let j = 0; j < res.list.length; j++) {
                  if(driveInfo.id == res.list[j].sDid){
                      var newItem={};
                      newItem.appName = driveInfo.appName;
                      newItem.driveId = driveInfo.id;
                      newItem.name = driveInfo.name;
                      newItem.filename = driveInfo.name;
                      newItem.fileId = res.list[j].id;
                      newItem.configId = res.list[j].configId;
                      that.catalogModel.push(newItem);
                  }
                  }
                   if(index == allDrivesArr.length-1){
                      that.catalogModelCopy = Object.assign([],that.catalogModel);
                   }
                 }
                 }else{
                      that.loading = false;
                      this.errorshow=true;
                      that.$forceUpdate();
                      this.$toast({
                            text: this.$t('language.exception.' + res.reason),
                            type: 'fail',
                            idValue: "backupRestore"
                        });
                 }
            });
         },
        //勾选父级目录时子目录应该也被勾选，勾选子目录时,父级目录不被勾选
        changeCheckStatus(data, sel) {
            //当节点选中时，其子节点也全部选中，若子节点全选中，则父节点选中
        },
        checkNode(checkedNodes,checkedKeys,halfCheckedNodes,halfCheckedKeys){
            if(this.HalfCheckedKeys && this.HalfCheckedKeys.includes(checkedNodes.keyId)){
             //如果该节点是半勾选状态则让其子节点都取消选中
             if(checkedNodes.children && checkedNodes.children.length){
                 for(let i=0;i < checkedNodes.children.length; i++){
                       this.$refs.tree1.setChecked(checkedNodes.children[i].keyId, false);
                       this.cancelCheck(checkedNodes.children[i]);  
                 }
                  this.$refs.tree1.setChecked(checkedNodes.keyId, false);
             }
              this.HalfCheckedKeys=[];
              return false;
            }
             this.HalfCheckedKeys = checkedKeys.halfCheckedKeys;
        },
        cancelCheck(checkedNodes){
         if(checkedNodes.children && checkedNodes.children.length){
                 for(let i=0;i < checkedNodes.children.length; i++){
                       this.$refs.tree1.setChecked(checkedNodes.children[i].keyId, false);
                       this.cancelCheck(checkedNodes.children[i]);  
                 }
                  this.$refs.tree1.setChecked(checkedNodes.keyId, false);
             }
        },
        includes(arr1, arr2) {
            return arr2.every(val => arr1.includes(val));
        },
        returnName(appName){
         let result;
         if(appName!='ownCloud'){
             result='icon '+appName+'-small drive-option-icon';
         }else{
             result='icon '+appName+'-small-box drive-option-icon';
         }
         return result;
        },
        loadNode(node, resolve) {
            let driveId;
            let fileId;
            let driveType;
            let that = this;
            if (node.level) {
                driveId = node.data.driveId;
                 let listData={
                     ud: JSON.parse(localStorage.getItem("user")).id,
                      id:this.backupId,//backupId
                      type:6,
                      bpid:node.data.configId,//父级id，根目录为0，从configId中获取
                      vd: this.versionNum,//版本号，从版本中获取
                   }
                that.$forceUpdate();
                that.Utils.doTasksRequest("list_restore", listData).then(res => {
                    if (res.status == 200) {
                        node.data.haveLoad=true;//表明该数据已经被加载过
                        let fileArr = [];
                        if (res.list.length) {
                             for (let i = 0; i < res.list.length; i++) {
                                res.list[i].driveId = driveId;
                                res.list[i].keyId = driveId + res.list[i].id;
                                res.list[i].pnode = node;
                                if (!res.list[i].dir) {
                                    res.list[i].leaf = true;
                                } else {
                                    res.list[i].leaf = false;
                                }
                            if(driveId == res.list[i].sDid){
                                     fileArr.push(res.list[i]);
                            }
                             }
                        } else {
                            node.data.leaf = true;
                        }
                        node.data.children = commonUtils.sortArr(fileArr, true, 0);
                         that.openPanel=false;
                         that.openPanel = true;
                        resolve(commonUtils.sortArr(fileArr, true, 0));
                        that.$nextTick(function () {
                            if (node.checked) {
                                that.changeCheckStatus(node.data, true)
                            }
                        });
                         that.$forceUpdate();
                    } else {
                      if(res.reason=='delete error'){
                             this.$toast({
                                text: that.$t('language.exception.reachedLimit'),
                                type: 'fail',
                                idValue: "backupRestore"
                            });
                        }
                        this.$toast({
                            text: this.$t('language.exception.' + res.reason),
                            type: 'fail',
                            idValue: "backupRestore"
                        });
                     resolve([]);
                    }
                });
            }
        },
        matchfileType(fileName) {
            return commonUtils.matchfileTypes(fileName);
        },
        executeRestore(){
            if(this.isExecute){
                return;
            }
            let that= this;
            let item=this.$parent.item;
            let taskId= this.$parent.item.id;
            let user = commonUtils.getUser();
            let toItems=[];
            if(!this.restoreItems){
                this.$toast({
                    text: that.$t('language.cloudBackup.selectRestoreItems'),
                    type: 'fail',
                    idValue: "backupRestore"
                });
                return false;
            }
            for(var i = 0;i < this.restoreItems.length;i++){
                if(!this.restoreItems[i].children){
                    this.restoreItems[i].children=[];
                }
            } 
            if(this.radioCurrent == 0){
                 toItems = null;
            }else{
                let node = this.$store.state.clickItem;
                if(!(node&&node.id)){
                   this.$toast({
                            text: that.$t('language.cloudBackup.selectRestoreTotles'),
                            type: 'fail',
                            idValue: "backupRestore"
                        });
                    return false; 
                }
                 toItems = taskTransferUtils.createSyncFromItems(node);
            }
            let backupArr = [];
            let allData = this.$parent.$parent.tasklistData;
            for (let i = 0; i < allData.length; i++) {
            if(allData[i].type == 6 && (allData[i].status == 'Running' || allData[i].status == 'Waiting')){
             backupArr.push(allData[i]);
             }
              }
            let executeRestoreData=new taskListUtils.executeRestoreData(user.id,6,taskId,"restore",this.vd,toItems,this.restoreItems,this.options);
            // if(this.$parent.item.tranferWay){
            //     executeRestoreData.tranferWay = this.$parent.item.tranferWay;
            // }
            this.isExecute = true;
            this.Utils.doTasksRequest("execute",executeRestoreData).then(result => {
                that.isExecute = false;
                if(result.status==200){
                    that.restoreShow=false;
                    if(executeRestoreData.type == 6){
                        // setTimeout(() => {
                            that.$parent.$parent.tasklistData[that.itemIndex].status ='Waiting';
                        that.$parent.$parent.tasklistData[that.itemIndex].tranferWay='restore';
                        that.$parent.$forceUpdate();
                        that.$parent.$parent.$forceUpdate();
                        that.$parent.initOneTask(item, function (res) {
                        that.$forceUpdate();
                        // if(backupArr.length){
                        //     }else{
                        //         that.$parent.$parent.tasklistData[that.itemIndex].status='Running';
                        //  }
                        //2022-1-10修改，running状态可能会倒退回waiting，所以默认进入waiting状态

                        that.$parent.initTask();
                        var progressData = new taskListUtils.progressData(commonUtils.getUser().id, item.type, item.id, item.workId);
                        that.$parent.getBackupSingleProgressDetail(that.$parent.$parent.tasklistData[that.itemIndex],progressData,that.itemIndex);
                        });
                        //}, 6000);
                    }
             
                }else if(result.reason=="invalidDrive"){
                    this.$refs.editCloudNoticDialog.init(toItems[0].driveId);
                }else{
                    that.$toast({
                            text:this.$t('language.exception.')+result.reason,
                            type: 'fail',
                            idValue: "backupRestore"
                        });
                    return false;  
                }
           });
        }
     },
      filters: {
        ellipsis(value) {
            if (!value) return '';
            if (value.length > 37) {
                return value.slice(0, 37) + '...';
            }
            return value;
        }
    }
}
//遍历看点击的节点是否存在子节点,并把子节点的ID装入数组
function traverseTree(node) {
    let child = node.children,
        arr = [];
    arr.push(node.keyId);
    if (child) {
        child.forEach(function (node) {
            arr = arr.concat(traverseTree(node));
        });
    }
    return arr;
}
</script>

<style>
#backupRestore{
    width: 500Px;
    height: 580Px;
}
.backup-options-body{
    width: 100%;
    height: 470px;
    /*no*/
    box-sizing: border-box;
    padding: 20px;
    /*no*/
    color: #6f7886;
}
.backup-line{
    width: 100%;
    height: 50Px;
    font-size: 14Px;
    line-height: 50Px;
    float: left;
}
.backup-middle{
     font-size: 14Px;
     margin-top: 15Px;
     float: left;
     width: 100%;
     height: 30Px;
}
.backup-box{
    width: 100%;
    height: 310Px;
    border: 1Px solid #f0f5fb;
    float: left;
}
.backup-box-relative{
    position:relative;
    box-sizing: border-box;
    padding: 10Px;
}
.backup-botton{
    width: 100%;
    height: 30Px;
    float: left;
    margin-top: 15Px;
    }
.backup-two-line{
    width: 100%;
    height: 35Px;
    font-size: 14Px;
    line-height: 35Px;
    float: left;
}
.backup-box-two{
    width: 100%;
    height: 385Px;
    float: left;
}
.backup-new-location{
    width: 100%;
    height: 100%;
    border: 1Px solid #f0f5fb;
}
.backButton{
    float:right;
    width:110Px;
    margin-right:10Px;
    background:#fff;
    border: 1Px solid #B3bcf6;
    color: #5065Bc;
}
.backButton:hover{
    float:right;
    width:110Px;
    margin-right:10Px;
    background:#fff;
    border: 1Px solid #B3bcf6;
    color: #5065Bc;
}
#backupRestore ul{
    list-style: none;
    color: #6f7886;
    margin: 0;
    padding-left: 15px;
    /*no*/
    display: block;
    list-style-type: disc;
    margin-inline-start: 0px;
    margin-inline-end: 0px;

}
#backupRestore li{
    list-style: none;
    width: 430px;
    /*no*/
    text-align: left;
    white-space: nowrap;
    margin: 0;
}
#backupRestore .tree-node-div {
    word-break: keep-all;
    white-space: nowrap;
    width: 430px;
    /*no*/
    height: 40px;
    /*no*/
    overflow: hidden;
}
#backupRestore .tree-nodes .el-loading-spinner .circular {
    height: 20px !important;
    /*no*/
    width: 20px !important;
    /*no*/
    position: relative;
    top: -20Px;
}

#backupRestore .tree-nodes .el-loading-spinner {
    margin-top: 0rem !important;
    height: 20Px !important ;
    top: 7%;
}
#sourceSelect .el-tree__empty-text {
    display: none;
}

.el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
}

.el-tree>.el-tree-node {
    display: inline-block;
    min-width: 100%;
}

#restore-tree-app .el-tree-node__content {
    height: 40px !important;
    /*no*/
    position: relative;
    font-size: 16px;
    /*no*/
    min-width: 400px;
    /*no*/
}

#backupRestore .el-tree {
    padding-left: 10px;
    /*no*/
}

.el-tree-node__label {
    font-size: 16px;
    /*no*/

}

.el-tree-node:focus>.el-tree-node__content {
    background-color: #ebf3fe !important;
}

.el-tree .el-tree-node__expand-icon.expanded {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}

.el-tree .el-icon-caret-right:before {
    background: url("../../../assets/images/workspace/icon_util.png");
    content: "";
    display: block;
    width: 16px;
    /*no*/
    height: 20px;
    /*no*/
    background-position: -875px -248px;
    /*no*/
}

.el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
    background: url("../../../assets/images/workspace/icon_util.png");
    content: "";
    display: block;
    width: 16px;
    /*no*/
    height: 20px;
    /*no*/
    background-position: -875px -248px;
    /*no*/
    transform: rotate(90deg);
    /*no*/
    position: relative;
    left: -3px;
    /*no*/
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #4181ff;
    border-color: #4181ff;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #4181ff;
}

.el-checkbox.is-bordered.is-checked {
    border-color: #4181ff;
}

.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #4181ff;
}

#backupRestore .el-checkbox__inner {
    border-radius: 0px !important;
    /*no*/
    width: 15px !important;
    /*no*/
    height: 15px !important;
    /*no*/
    border: 1px solid #4181ff !important;
    /*no*/
    position: absolute;
    top: -5.5px;
    /*no*/
    bottom: 0;
    margin: auto;
}
 .el-checkbox__inner::after {
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    content: "";
    border: 2px solid #fff !important;
    /*no*/
    border-left: 0 !important;
    border-top: 0 !important;
    height: 11px !important;
    /*no*/
    width: 4.3px !important;
    /*no*/
    left: 4px !important;
    /*no*/
    position: absolute;
    top: -1.5px !important;
    /*no*/
    -webkit-transform: rotate(45deg) scaleY(0);
    transform: rotate(45deg) scaleY(0);
    -webkit-transition: -webkit-transform 0.05s ease-in 0.05s !important;
    transition: -webkit-transform 0.05s ease-in 0.05s !important;
    transition: transform 0.05s ease-in 0.05s !important;
    transition: transform 0.05s ease-in 0.05s,
        -webkit-transform 0.05s ease-in 0.05s !important;
    transition: transform 0.05s ease-in 0.05s,
        -webkit-transform 0.05s ease-in 0.05s !important;
    -webkit-transform-origin: center;
    transform-origin: center;
    text-shadow: 0 0 black;
}

.tree-icon-position {
    margin: 0px 10px 0 0px;
    /*no*/
    float: left;
}

.node-name {
    display: block;
}

.is-leaf.el-tree-node__expand-icon.el-icon-caret-right:before {
    width: 16px;
    /*no*/
    height: 20px;
    /*no*/
    content: "" !important;
    background: none !important;
}

.drive-option-icon {
    float: left;
    position: relative;
    top: -2px;
    /*no*/
}

.folder-option-icon {
    float: left;
}



#restore-tree-app .el-icon-loading {
    width: 16px;
    /*no*/
    height: 16px;
    /*no*/
    border: 0.5px solid #5562b4;
    /*no*/
    border-left-color: #5562b4;
    border-right-color: #f0f7ff;
    border-top-color: #f0f7ff;
    border-radius: 50%;
    /*圆角*/
    animation: rotating 0.1s linear ease-in-out infinite;
    
}

#restore-tree-app .el-icon-loading:before {
    content: '';
}

#restore-tree-app .el-tree-node__loading-icon {
    margin-right: 5Px;
}
.el-checkbox__input.is-indeterminate .el-checkbox__inner::before{
    top: 5Px !important;
}

#backupRestore .el-loading-mask {
    z-index: 999;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/backup_restore_popup.vue